import { compose } from '@reduxjs/toolkit';
import { withComponentAccessHandler, withPackPreviewGuard } from 'lib/hoc';
import { PermissionLevels } from 'lib/types';
import { FC } from 'react';

type Props = {
  allowedRoles: PermissionLevels[];
}

export const AccessHandler: FC<Props> = ({ allowedRoles, children }) => {
  const Component = () => {
    return children;
  }

  const ComponentWithAccessHandler = compose(
    withPackPreviewGuard(),
    withComponentAccessHandler(allowedRoles)
  )(Component);

  return <ComponentWithAccessHandler />;
}